import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import Jobs from './Jobs';
import { SubmitInvoiceWrapper } from './SubmitInvoice';
import Invoices from './Invoices';
import JobDetail from './JobDetail';
import Document from './Document';
import Account from './Account';
import LogOut from './LogOut';
import NavBar from './NavBar';
import { client, common, Collection, FilterCollection } from 'plato-js-client';
import { Container } from 'reactstrap'
import moment from 'moment'

let apiRoot = (window.location.hostname === 'suppliers.originalcottages.co.uk' ? 'https://toccl.api.tabs-software.co.uk' : 'https://test.plato.hc-dev.co.uk');
if (sessionStorage.apiHost) {
  apiRoot = sessionStorage.apiHost;
}

client.getInstance().setInstance({
  apiRoot,
  apiPrefix: '/v2',
  oAuthRedirectUrl: window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/oauth',
  clientId: '12_6di1o20nqt4wkc4gwgs0kkc4wk8c0c0ck4wkwssgww0o8coo4w',
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount = () => {
    if (window.location.hash) {
      // synchronously save the token to localStorage
      client.getInstance().oAuthCallback(window.location.hash);
    }

    this.whoAmI().then(supplier => {
      this.getVAT()
      this.addProgram(supplier);
      this.getProperties(supplier);
      this.getBookingBrands();
      this.getReports();
    });
  };

  logOut = () => {
    this.setState({ user: null });
    client.getInstance().oAuthLogout();
  };

  getVAT = () => {
    // Only fetch vat rates once a day max.
    let vr = JSON.parse(localStorage.getItem('vatrates'));

    if (!vr || vr.cachedDate !== moment().format('DD/MM/YYYY')) {
      var vatrates = new Collection({
        path: 'vatrate',
        object: common.VatRate,
      });
      vatrates.fetch().then(() => {
        localStorage.setItem('vatrates', JSON.stringify({
          vatrates: vatrates,
          cachedDate: moment().format('DD/MM/YYYY')
        }));
      });
    }
  };

  getProperties = supplier => {
    let properties = new FilterCollection({
      path: 'property',
      object: common.Property,
    });

    properties.limit = 99;
    properties.fields = 'id:name:tabspropref:primarybookingbrand';

    properties.addFilters({
      activesupplierid: supplier.id
    });

    properties.fetch().then(
      () => this.setState({ properties })
    );
  }

  getReports = () => {
    let reports = new FilterCollection({
      path: 'report',
      object: common.Report,
    });

    reports.addFilters({
      filename: 'PropertyQuestionAnswer.rptdesign'
    });

    reports.fetch().then(
      () => this.setState({ reports })
    );
  }

  getBookingBrands = () => {
    let bookingBrands = new Collection({
      path: 'bookingbrand',
      object: common.BookingBrand,
    });

    bookingBrands.fetch().then(
      () => this.setState({ bookingBrands })
    );
  }

  whoAmI = () => {
    return client.getInstance().whoAmi().then((response) => {
      var actor = common.ActorInstance.call(this, response.entity.type.toLowerCase());
      var a = new actor(response.entity.id);
      a.mutateResponse(response.entity);
      this.setState({ user: a });
      return a;
    });
  };

  addProgram = supplier => {
    // We only want to add the program to suppliers
    if (supplier.type !== 'Supplier') {
      return;
    }
    var supplierPrograms = new Collection({
      path: 'program',
      object: common.ActorProgram,
      parent: supplier,
    });
    supplierPrograms.fetch()
      .then((programs) => {
        const now = moment();
        const supplierProgramId = 1;
        const hasActiveSupplierPortalProgram = programs.collection.find(function (supplierProgram) {
          // Check if actor has supplier portal within valid dates
          return (typeof supplierProgram.program !== 'undefined'
            && supplierProgram.program.id === supplierProgramId
            && now.isSameOrAfter(supplierProgram.fromdate)
            && now.isSameOrBefore(supplierProgram.todate)
          );
        });
        // If program already exists, don't add again
        if (typeof hasActiveSupplierPortalProgram !== 'undefined') {
          return;
        }
        // No program found, add it
        return this.createProgram(
          supplier,
          supplierProgramId,
          now.format('YYYY-MM-DD')
        );
      });
  }

  createProgram = (supplier, programId, fromDate) => {
    const supplierProgram = new common.ActorProgram();
    supplierProgram.program.id = programId;
    supplierProgram.fromdate = fromDate;
    supplierProgram.todate = '2100-01-01';
    supplierProgram.parent = supplier;
    return supplierProgram.create();
  }

  updateUser = fields => this.state.user.update(fields);

  /* Not used */
  addContactDetail = (type, value) => {
    if (type === 'Phone') {
      var contactDetail = new common.ActorContactDetailPhone();
      contactDetail.countrycode = '44';
      contactDetail.subscribernumber = value;
    } else if (type === 'Address') {
      contactDetail = new common.ActorContactDetailAddress();
      contactDetail.address.mutateEntity(value);
    } else {
      contactDetail = new common.ActorContactDetailOther();
      contactDetail.value = value;
    }
    contactDetail.parent = this.state.user;
    contactDetail.contactmethodtype = type;
    return contactDetail.create().then(() => this.state.user.contactdetails.push(contactDetail));
  }

  render() {
    if (!this.state.properties) {
      return null;
    }

    return (
      <BrowserRouter>
        <Container>
          <NavBar user={ this.state && this.state.user } />
          {/* <Alert color="danger" className="mt-2">
            As per the government issued instruction that everyone must stay at home, we have advised customers they will not be able to travel to their holiday destination for at least the next three weeks. Cleans will not be required for this period.
          </Alert> */}
          <React.Fragment>
            { this.state && this.state.user &&
              <React.Fragment>
                <Route path='/' exact render={ (routeProps) => <Jobs { ...routeProps } user={ this.state.user } properties={ this.state.properties } bookingBrands={ this.state.bookingBrands } /> } />
                <Route
                  path='/job/:workorderid'
                  exact render={
                    (routeProps) => <JobDetail {...routeProps} user={this.state.user} properties={this.state.properties} reports={this.state.reports} />
                  }
                />
                <Route path='/submitinvoice/:bookingid/:serviceid' render={ (routeProps) => <SubmitInvoiceWrapper { ...routeProps } user={ this.state.user } workOrderSuppliers={ this.state.workOrderSuppliers } properties={ this.state.properties } /> } />
                <Route path='/invoices' exact render={ (routeProps) => <Invoices { ...routeProps } user={ this.state.user } properties={ this.state.properties } /> } />
                <Route path='/document/:id' component={ Document } />
                <Route path='/account' render={ (routeProps) => {
                  return <Account { ...routeProps } user={ this.state.user } properties={ this.state.properties } updateUser={ this.updateUser } addContactDetail={ this.addContactDetail } />
                } } />
              </React.Fragment>
            }
            <Route path='/logout' render={ (routeProps) => {
              return <LogOut { ...routeProps } logOut={ this.logOut } whoAmI={ this.whoAmI } />;
            } } />
            <Route path='/oauth' render={ () => {
              // redirect AFTER window.location.hash has been used
              if (this.state && this.state.user) {
                var previousPath = sessionStorage['tabs2:previousPath'];
                if (previousPath && previousPath.indexOf('/logout') !== 0) {
                  return <Redirect to={ previousPath } />;
                }
                return <Redirect to='/' />;
              }
              return null;
            } } />
          </React.Fragment>
        </Container>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js